import React from 'react';

export default function MethodImage({ image }) {
	return <img src={image} alt="" />
}